import { useContext, useEffect, useState } from "react";
import { ErrorAlert } from "../components/alerts";
import BreadCrumbs from "../components/breadcrumsb";
import { PageContainer } from "../components/page";
import Select from "react-select";
import { getValidVenues, getVenueSetupStatusData } from "../api/new-api";
import { PEProgressBar } from "../components/linear-progress";
import SetupStatusContainer from "./SetupStatusContainer";
import { observer } from "mobx-react";
import { UserStore } from "..";
import { useNavigate } from "react-router";

const PAGE_TITLE = "Venue Setup & Status";

const VenueSetupStatusPage = () => {
  const userStore = useContext(UserStore);
  const navigate = useNavigate();
  const { selectedVenue } = userStore;
  const [venuesOptions, setVenuesOptions] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>({
    value: "",
    label: "",
  });
  const [error, setError] = useState<any>("");
  const [loading, setLoading] = useState(true);

  const [venueData, setVenueData] = useState<any>();
  const fetchValidVenues = async () => {
    setError("");
    try {
      const res = await getValidVenues();
      if (res?.data?.validVenues?.length > 0) {
        setVenuesOptions(res?.data?.validVenues);
        return;
      }
      setError("Something wrong getting venues");
    } catch (err) {
      console.log(err);
      setError("Something wrong getting venues");
    } finally {
      setLoading(false);
    }
  };

  const fetchSelectedVenueData = async () => {
    setLoading(true);
    try {
      const res = await getVenueSetupStatusData(selected.value);
      if (res?.data?.status) {
        setVenueData(res.data.status);

        return;
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleVenue = () => {
    if (selectedVenue?.venueId !== 17) {
      navigate("/");
    }
  };

  useEffect(() => {
    fetchValidVenues();
    handleVenue();
  }, [selectedVenue]);

  useEffect(() => {
    if (selected.value) {
      fetchSelectedVenueData();
    }
  }, [selected.value]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/venue-setup-status", breadcrumbName: PAGE_TITLE },
        ]}
      />
      {loading && <PEProgressBar />}
      {error && <ErrorAlert message={error} />}

      <div className="text-center mt-10 text-gray-700 dark:text-gray-400">
        <p className="mb-2 font-normal text-2xl">
          {venuesOptions.length} VENUES FOUND
        </p>
        <p className="mb-2 font-normal text-sm italic">
          *select a venue below to setup
        </p>
        <div>
          {" "}
          <Select
            value={selected}
            options={venuesOptions.map(({ venueName, venueId }) => ({
              value: venueId,
              label: `${venueName} (${venueId})`,
            }))}
            onChange={(newValue) => setSelected(newValue)}
          />
        </div>
      </div>
      <div>
        {!loading && venueData && (
          <SetupStatusContainer
            venue={selected}
            venueData={venueData}
            fetchSelectedVenueData={fetchSelectedVenueData}
          />
        )}
      </div>
    </PageContainer>
  );
};

export default observer(VenueSetupStatusPage);
